var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Field as FFField } from 'react-final-form';
import React from 'react';
var defaultParse = function (value) { return (value); };
/*
 * O field do final-form possui um defaultParse, que quando é atribuida uma string vazia
 * o valor é convertido em valor undefined, e isso acaba gerando um problema, pois se é
 * aberta uma tela de edição e é apagado o valor de um campo, esse atributo deixa de
 * existir no payload, logo não é enviado ao backend e nem atualizado, assim voltando ao
 * valor anterior.
 *
 * See:
 *  https://github.com/final-form/react-final-form/issues/130
 *  https://github.com/final-form/react-final-form/blob/master/src/useField.js#L24
 */
var Field = function (props) { return React.createElement(FFField, __assign({ parse: defaultParse }, props)); };
export default Field;
//# sourceMappingURL=Field.js.map